import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import bannerImg from '../img-landing/herobanner.png'

function MainBanner() {

  function movetocontact() {
    document.getElementById('contact').scrollIntoView({
      behavior: 'smooth'
    });
  }

  return (
    <Box className="displayStyle mobilemainbrand py80" sx={{ position: 'relative' }}>
      <Box sx={{ py: 4, width: '50%' }}>
        <Typography variant="p" gutterBottom className='font600  fontSize62 lineHeight70'>
          Create. Captivate. Convert.
          {/* <br /> */}
          {/* <Typography variant="span" className='textgradient fontSize62'>
            GrooveNexus
          </Typography> */}
        </Typography>
        <Typography sx={{ width: '90%', mt: 3 }} variant="subtitle1" gutterBottom className='fontSize16 '>
          We create versatile, platform-ready content that drives engagement and action.
        </Typography>
        <Box display={'flex'} flexDirection={'column'} alignItems={'baseline'} justifyContent={'left'} gap={2}>
          <Button onClick={movetocontact} variant="contained" className='buttonGradient font600 fontSize16 borderRadius border-none boxshadownone' sx={{ mt: 3 }}>
            Show. Don’t Tell.
          </Button>
          <Typography variant='span'>
            Create content that speaks louder than words.
          </Typography>
        </Box>
      </Box>
      <Box sx={{
        textAlign: 'center', position: 'absolute',
        right: '-20px',
        width: '760px',
        top: '41px',
        display:{xs:'none', sm:'none', md:'block'}
      }}>
        <img src={bannerImg} alt="Brand Banner" width="100%" />
      </Box>
    </Box>
  );
}
export default MainBanner;
